class LockEntityProperties {

    constructor() {

        return {
            restrict: 'A',
            link: ($scope, $el, $attr) => {
                $attr.$observe('lockEntityProperties', (newVal) => {
                    if(!!newVal) {
                        let isDisabled = newVal == "true";
                        $el.find('*').attr("disabled", isDisabled);
                    }
                    else {
                         $el.find('*').attr("disabled", false);   
                    }
                });
            }
        };

    }

}

angular.module('cpm')
    .directive('lockEntityProperties', [() => {
        'use strict';
        return new LockEntityProperties();
    }]);